import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getSegmentsList.query';

export const getSegmentsList = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getSegmentsList${querystring}`;
    return network.get(url).then((response) => response.data);
};
